export default __webpack_public_path__ + "static/media/cs_client.83cd5cc7.png";